import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';

// import './index.css';
// import './scss/style.scss';

import HttpsRedirect from 'react-https-redirect';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import { createLogger } from 'redux-logger';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createMiddlewareSaga from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { IntlProvider } from 'react-intl';
import Services from 'services/index';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Store from './redux/reducers';
import rootSagas from './redux/sagas';
import i18n from './i18n';

import CachedProvider from 'providers/CachedProvider';
import { showError } from 'helpers/handleError';

//* setup middleware
const sagaMiddleware = createMiddlewareSaga();
let middleware = applyMiddleware(sagaMiddleware);

if (process.env.NODE_ENV !== 'production') {
  middleware = composeWithDevTools(applyMiddleware(sagaMiddleware, createLogger()));
}

export const store = createStore(Store, middleware);
sagaMiddleware.run(rootSagas);
Services.setupInterceptors(store);

const client = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      showError(error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <QueryClientProvider client={client}>
    <Provider store={store}>
      <CachedProvider>
        <IntlProvider locale='en'>
          <I18nextProvider i18n={i18n}>
            <HttpsRedirect>
              <App />
            </HttpsRedirect>
          </I18nextProvider>
        </IntlProvider>
      </CachedProvider>
    </Provider>
  </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();

//! For use dispatch outside React Component
export const storeRedux = store;
